import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FreudButtonModule } from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';

import { ContactFilterPromptuariesComponent } from './contact-promptuaries-filter.component';

@NgModule({
	declarations: [ContactFilterPromptuariesComponent],
	imports: [CommonModule, TranslateModule, FreudButtonModule],
	exports: [ContactFilterPromptuariesComponent],
	providers: [],
})
export class ContactPromptuariesFilterModule {}
